<aside id="sidebar">


    <div id="sidebar-wrap">

        <div class="panel-group slim-scroll" role="tablist">
            <div class="panel panel-default">
                <div class="panel-heading" role="tab">
                    <h4 class="panel-title">
                        <a data-toggle="collapse" href="#sidebarNav">
                            Navigation <i class="fa fa-angle-up"></i>
                        </a>
                    </h4>
                </div>
                <div id="sidebarNav" class="panel-collapse collapse in" role="tabpanel">
                    <div class="panel-body">


                        <!-- ===================================================
                    ================= NAVIGATION Content ===================
                    ==================================================== -->
                        <ul id="navigation">
                            <li routerLinkActive="active"><a [routerLink]="['/'+AppFrontRoutes.DASHBOARD]"><i
                                        class="fa fa-dashboard"></i> <span>{{language?.general.dashboard |
                                        titlecase}}</span></a></li>

                            <li *ngxPermissionsOnly="AppPermissions.DEADLINE" routerLinkActive="active">
                                <a [routerLink]="['/'+AppFrontRoutes.Deadline_List]"><i class="fa fa-bomb"></i>
                                    <span>{{language?.general.deadlines | titlecase}}</span></a>
                            </li>



                            <li *ngxPermissionsOnly="AppPermissions.SERVICING" #rla="routerLinkActive"
                                routerLinkActive="active" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="fa fa-wrench"></i>
                                    <span>{{language?.general.servicing | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul [ngStyle]="{display:(rla.isActive ? 'block' : 'none' )}">
                                    <li *ngxPermissionsOnly="AppPermissions.Servicing_List" routerLinkActive="active">
                                        <a [routerLink]="['/'+AppFrontRoutes.Servicing_List]" class="submenu"><i
                                                class="fa fa-caret-right"></i> {{language?.general.listEquipment |
                                            titlecase}}</a>
                                    </li>

                                    <li *ngxPermissionsOnly="AppPermissions.SERVICING"
                                        routerLinkActive="active"><a
                                            [routerLink]="['/'+AppFrontRoutes.MAINTENANCE_PLANS]" class="submenu"><i
                                                class="fa fa-caret-right"></i> {{language?.general.maintPlans |
                                            titlecase}}</a></li>
                                </ul>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.HUMAN_RESOURCE" #hra="routerLinkActive"
                                routerLinkActive="active" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="fa fa-group"></i>
                                    <span>{{language?.general.humanRes | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul [ngStyle]="{display:(hra.isActive ? 'block' : 'none' )}">
                                    <li><a [routerLink]="['/'+AppFrontRoutes.EMPLOYEE_LIST]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.employee |
                                            titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.Notification_List]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.notification |
                                            titlecase}}</a></li>

                                    <li><a [routerLink]="['/'+AppFrontRoutes.SKILLS_LIST]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.skills |
                                            titlecase}}</a></li>

                                    <li><a [routerLink]="['/'+AppFrontRoutes.MEDICAL_EXAMINATION]"><i class="fa fa-caret-right"></i> {{language?.general.medicalExam |
                                            titlecase}}</a></li>
                                </ul>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.MEASUREMENT_TOOL" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="glyphicon glyphicon-screenshot"></i>
                                    <span>{{language?.general.measTools | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.MEASUREMENT]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.listMeasTools |
                                            titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.CALIBRATION_PLANS]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.calibPlans |
                                            titlecase}}</a></li>
                                </ul>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.PROBLEM_SOLVING">
                                <a [routerLink]="['/'+AppFrontRoutes.PROBLEM_SOLVING]"><i
                                        class="glyphicon glyphicon-question-sign"></i>
                                    <span>{{language?.general.probSolving | titlecase}}</span></a>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.DOCUMENT_MANAGEMENT">
                                <a [routerLink]="['/'+AppFrontRoutes.DOCUMENT_MANAGEMENT]"><i
                                        class="fa fa-folder-open"></i> <span>{{language?.general.docManag |
                                        titlecase}}</span></a>
                            </li>


                            <li *ngxPermissionsOnly="AppPermissions.CUSTOMERS" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="glyphicon glyphicon-shopping-cart"></i>
                                    <span>{{lang?.registry | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['/'+AppFrontRoutes.CUSTOMERS]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.customers |
                                            titlecase}}</a>
                                    </li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.SUPPLYERS]"><i class="fa fa-caret-right"></i> {{lang?.suppliers | titlecase}}</a></li>
                                </ul>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.CONSULTANCY" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="glyphicon glyphicon-retweet"></i>
                                    <span>{{language?.general.consultancy | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul>
                                    <li>
                                        <a [routerLink]="['/'+AppFrontRoutes.CONSULTANCY]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.contractList |
                                            titlecase}}</a>
                                    </li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.REPORTING]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.consReporting |
                                            titlecase}}</a></li>
                                </ul>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.ACADEMY" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="fa fa-graduation-cap"></i>
                                    <span>{{language?.general.academy | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.SCHEDULEDCOURSES]"><i
                                                class="fa fa-caret-right"></i>
                                            {{language?.general.scheduledCourses | titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.COURSE_CATELOG]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.courseCatalog |
                                            titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.QUALIFIED_TEACHER]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.qualifiedTeach
                                            | titlecase}}</a></li>
                                </ul>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.PROJECT" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="fa fa-pencil"></i>
                                    <span>{{language?.general.project | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.PROJECT]"><i class="fa fa-caret-right"></i>
                                            {{language?.general.projectList |
                                            titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.PROJECT_REPORTING]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.projReporting |
                                            titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.PROJECT_CLASS]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.projClass |
                                            titlecase}}</a></li>
                                </ul>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.AUDIT" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="fa fa-eye"></i>
                                    <span>{{language?.general.audit | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.AUDIT_LIST]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.auditList |
                                            titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.STANDARD]"><i
                                                class="fa fa-caret-right"></i> {{language?.general.auditStd |
                                            titlecase}}</a></li>
                                </ul>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.AUDIT" class="dropdown">
                                <a role="button" tabindex="0" class="SidebarMenuHandle">
                                    <i class="fa fa-eye"></i>
                                    <span>{{lang?.privacy | titlecase}}</span>
                                    <i class="fa fa-plus"></i>
                                </a>
                                <ul>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.PRIVACY_TREATMENT_REGISTER]"><i
                                                class="fa fa-caret-right"></i> {{lang?.treatment_register |
                                            titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.PRIVACY_APPOINTMENT_REGISTER]"><i
                                                class="fa fa-caret-right"></i> {{lang?.appointment_data_processfor |
                                            titlecase}}</a></li>
                                    <li><a [routerLink]="['/'+AppFrontRoutes.STANDARD]"><i
                                        class="fa fa-caret-right"></i> {{lang?.informative |
                                    titlecase}}</a></li>                                            
                                </ul>
                            </li>          
                            
                            <!-- <li routerLinkActive="active">
                                <a [routerLink]="['/'+AppFrontRoutes.CALENDAR]">
                                    <i class="fa fa-calendar"></i> 
                                    <span>{{lang?.calendar | titlecase}}</span>
                                </a>
                            </li> -->
   
                            <!-- 
                            <li *ngxPermissionsOnly="AppPermissions.AUDIT" routerLinkActive="active">
                                <a [routerLink]="['/'+AppFrontRoutes.ADMIN_TICKET_LIST]"><i class="fa fa-bomb"></i>
                                    <span>{{language?.general.support | titlecase}}</span></a>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.AUDIT" routerLinkActive="">
                                <a [routerLink]="['/'+AppFrontRoutes.ADMIN_MAIL_CONFIG]"><i class="fa fa-bomb"></i>
                                    <span>Configuration and Email</span></a>
                            </li> -->
                            <!-- 
                            <li *ngxPermissionsOnly="AppPermissions.AUDIT">
                                <a  [routerLink]="['/'+AppFrontRoutes.SDASHBOARD]"><i class="fa fa-folder-open"></i> <span>Super Admin</span></a>
                            </li>

                            <li *ngxPermissionsOnly="AppPermissions.AUDIT">
                                <a  [routerLink]="['/'+AppFrontRoutes.INSTALLATION_LIST]"><i class="fa fa-folder-open"></i> <span>Installation List</span></a>
                            </li> -->

                        </ul>
                        <!--/ NAVIGATION Content -->


                    </div>
                </div>
            </div>

        </div>

    </div>


</aside>